import IpsCalendar from './IpsCalendar.vue';
import '../../../styles/custom.scss';

export default IpsCalendar;
